import useMonolithApiMutation from '@/hooks/api/useMonolithApiMutation';
import { SimpleErrorResponse } from '@/models/Error';
import { queryClient } from '@/utils/query';

import { addonTrialQueryKey, TrialAddonType } from './useAddonTrialShow';

export const useAddonTrialCreate = (orgSlug: string, type: TrialAddonType, onSuccess: () => void | Promise<void>) => {
  const { mutate, ...rest } = useMonolithApiMutation<void, SimpleErrorResponse, { type: TrialAddonType }>(
    `/organizations/${orgSlug}/addon_trials`,
    'POST',
    {
      onSuccess: async () => {
        queryClient.invalidateQueries({ queryKey: addonTrialQueryKey(orgSlug, type) });
        await onSuccess();
      },
    },
  );

  return { create: () => mutate({ type }), ...rest };
};
